const o = (s) => s.filter((e) => typeof e == "string" && e).join(" ");
export {
  o as mergeClassNames
};
//# sourceMappingURL=mergeClassNames.mjs.map
